import { render, staticRenderFns } from "./BreadcrumbSection.vue?vue&type=template&id=02f27ca3&"
import script from "./BreadcrumbSection.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\marci\\Desktop\\majorel-china-static\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f27ca3')) {
      api.createRecord('02f27ca3', component.options)
    } else {
      api.reload('02f27ca3', component.options)
    }
    module.hot.accept("./BreadcrumbSection.vue?vue&type=template&id=02f27ca3&", function () {
      api.rerender('02f27ca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/BreadcrumbSection.vue"
export default component.exports